import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IAlert } from '@carm/_core/alerts/models/alert.model';
import { AlertService } from '@carm/_core/alerts/services/alert.service';
import { NotificationService } from '@carm/_core/notification-mgt/facade/notifcation.service';
import { IFormErrorNotification, INotification } from '@carm/_core/notification-mgt/models/notification.model';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { Observable, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CarmResources, GroupTypes } from '@carm/_core';
import { BaseComponent } from '@carm/_utils/base.component';

@Component({
  selector: 'carm-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss'],
})
export class AlertsComponent extends BaseComponent implements OnInit, OnChanges {

  @Input() displayAlertsForPage: string;
  @Input() isPublic: boolean;

  groupTypeEnum = GroupTypes;
  carmResourcesEnum = CarmResources;
  alerts$: Observable<IAlert[]>;
  pageNotification$: Observable<INotification>;
  formErrorNotification$: Observable<IFormErrorNotification>;

  constructor(
    private alertService: AlertService,
    private notificationService: NotificationService ) {
      super();
    }

  ngOnInit() {
    this.loadAlerts();
    this.pageNotification$ = this.notificationService.getPageNotification();
    this.formErrorNotification$ = this.notificationService.getFormErrorNotification();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.displayAlertsForPage) {
      this.loadAlerts();
    }
  }

  private loadAlerts(): void {
    if (this.displayAlertsForPage) {
      this.alerts$ = this.alertService.getAlerts(this.displayAlertsForPage).pipe(takeUntil(this.destroy$));
    } else {
      this.alerts$ = of([]);
    }
  }

  getAlertDetailLink(containerPageUid: string) {
    return containerPageUid ? RoutesConst.AlertDetails + '/' + containerPageUid : null;
  }
}
